import styled from 'styled-components';
import { colors } from '~/styles/colors';
import { primaryScrollbar } from '~/styles/scrollbar';

export const Table = styled.table`
  white-space: wrap;
  border-collapse: collapse;

  &, th, td {
    border: 1px solid ${colors.stroke['soft-200']};
    text-align: center;
    padding: 4px 10px;
  }

  th, td {
    min-width: 268px;
    max-width: 268px;
  }
`;

export const GuideContainer = styled.div`
  overflow: auto;
  margin-top: 24px;
  padding-bottom: 24px;
  width: 100%;
  ${primaryScrollbar}
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
